import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { LoginService } from './login.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Login } from './login';
import { BsModalService, BsModalRef,ModalOptions } from 'ngx-bootstrap/modal';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../Master/user/user'; 
import { HubConnectionBuilder } from '@aspnet/signalr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../Shared/commondialog/commondialog.component';
import { loginSignalRService } from './login.signalR.service';
import { LocationStrategy } from '@angular/common';
import { CommonService } from '../Shared/commonservice';
import { NgxSpinnerService } from "ngx-spinner";
import {encryptdecrypt} from '../encryptdecrypt';
import {ChangePasswordService} from '../changepassword/changepassword.service';
import { DataTableBodyCellComponent } from '@swimlane/ngx-datatable';
import { LocalService } from '../local.service';
import { environment } from '../../environments/environment';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthService, loginSignalRService]
})
export class LoginComponent implements OnInit {

  // private _hubConnection: HubConnectionBuilder;
  loginForm: FormGroup;
  forgotuserForm: FormGroup;
  changepsswordForm: FormGroup;
  loading = false;
  submitted = false;
  submittedpassword=false;
  returnUrl: '/home';
  error = '';
  postresult: boolean;
  returnurl: string = '';
  code: any;
  bsModalRef: BsModalRef;
  changepasswordModalRef: BsModalRef;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  };
  encryptUsername=''; encryptPassword='';encryptUserid='';userid =0;
  passwordComplexity=0;
  public barLabel: string = "Password strength:";
  public apitoken = this.localService.getJsonValue('apitoken');
  autologUrl:string=environment.autologUrl;
  AdminTeamId:number=environment.AdminTeamId;
  autologUserTeamId:number=environment.autologUserTeamId;
  userrole:string='';autologadmin:number=0;
  public account = {  
        password: null  
      }; 
      btndisabled=false;
      isautologuseronly:number=0;isautologteam:number=0;
  constructor(
    public signalrservice: loginSignalRService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private authService: AuthService,
    private dialogService: DialogService,
    private location: LocationStrategy,
    private commonService: CommonService,
    private SpinnerService: NgxSpinnerService,
    private changeservice:ChangePasswordService,
    private localService: LocalService
  ) {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit() {

    //if (this.authService.isLoggednIn) {
    //  this.router.navigate(['/home']);
    //}

    this.loginForm = this.formBuilder.group({
      emailid: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    this.forgotuserForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]

    });

    this.changepsswordForm = this.formBuilder.group({
      oldpassword: ['', Validators.required],
      newpassword: ['', Validators.required],
      confirmpassword: ['', Validators.required]
    });
    if (this.localService.getJsonValue("userid") != null) {
      //localStorage.clear();
      //this.localService.clearToken();
      //localStorage.removeItem("LoggedIn");

    }
    this.route.queryParams
      .subscribe(params => this.returnurl = params['returnUrl']);
    // reset login status
    // this.loginService.logout();

    //SSO

    this.route.queryParams
      .subscribe(params => this.code = params['code']);

    if (this.code != '' && this.code != undefined && this.code != null) {
      this.SpinnerService.show();
      this.ssoPost(this.code);

    }

  }

    // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  get fuser() { return this.forgotuserForm.controls; }

  get p() { return this.changepsswordForm.controls; }

  openforgotuserModal(template: TemplateRef<any>, user?: User) {
    this.bsModalRef = this.modalService.show(template);

  }

  PostforgotUser(user: User) {

    if (this.fuser.email.value != '') {
      this.SpinnerService.show()
      this.commonService.sendemail(this.fuser.email.value, "forgotpassword").subscribe(res => {
        if (res.status == 200) {
          this.postresult = true;
          this.ngOnInit()
          this.SpinnerService.hide();
        };
        this.toastr.success("Email Sent successfully");
        this.doHide();
      },
        error => {
          this.toastr.error(error.error);
          this.postresult = false;
          this.SpinnerService.hide();
        });
    }
    else {
      this.toastr.error("Please Enter Email Id");
    }
  }
  
  getfrmValue($event) {    
    this.passwordComplexity = $event;
      }

  onSubmit(http: HttpClient,template: TemplateRef<any>) {
      this.btndisabled=true;
    this.submitted = true;
    console.log("login");
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.btndisabled=false;
      return;
    }
    let a= new encryptdecrypt(); 
    let _encryptPassword = a.encryptUsingAES256(this.f.password.value.toString());
    this.loginService.login(a.encryptUsingAES256(this.f.emailid.value.toString()), _encryptPassword.toString(), 0).subscribe((Login: any) => {

      this.authService.setSecureToken(Login.token);
      // Set the User data
      this.localService.setJsonValue('userid', Login.userid);
      this.localService.setJsonValue('username', Login.firstname);
      this.localService.setJsonValue('emailid', this.f.emailid.value);
      this.localService.setJsonValue('logid', Login.logid);
      this.localService.setJsonValue('apitoken', Login.apitoken);
      this.localService.setJsonValue('isautologuseronly', Login.isautologuseronly);
      this.localService.setJsonValue('isautologteam', Login.teamid); 
      this.localService.setJsonValue('isautologadmin', Login.isautologadmin);  

      console.log(Login.token);     
      console.log(Login.apitoken); 
       console.log('Login.firstname');    
       console.log(Login.firstname); 
        console.log('this.f.emailid.value');     
       console.log(this.f.emailid.value);    
      this.isautologuseronly=+Login.isautologuseronly;
      this.isautologteam=+Login.teamid;
      this.apitoken=Login.apitoken;
      this.userrole=Login.userrole;
      this.autologadmin=+Login.isautologadmin;
      //localStorage.setItem("userid", Login.userid);
      //localStorage.setItem("username", Login.firstname);
      //localStorage.setItem("emailid", this.f.emailid.value);
      //localStorage.setItem("logid", Login.logid);

      this.signalrservice.createConnection();
      this.signalrservice.registerOnServerEvents();
      this.signalrservice.startConnection();

     // this.router.navigate(['/home']);
      if (this.returnurl != '' && this.returnurl != undefined)
        this.router.navigateByUrl(this.returnurl);
      else{
        if((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
           && this.userrole=='Admin') ||((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
            && this.autologadmin==1))
                  ||(this.isautologuseronly==2)){
        this.router.navigate(['/homepage']);
       // this.localService.setJsonValue('navmenu', false);
      }
        else if(this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId && this.userrole=='User'){
        
          let openAutologUrl='';  
          openAutologUrl=this.autologUrl+this.apitoken+'&auth=acrn';
          localStorage.clear();
          // Clear the localStorage
          this.localService.clearToken();
         window.open(openAutologUrl,"_self");                    
        }
        else
        this.router.navigate(['/home']);
      }
     
      //  
    },

      (err: HttpErrorResponse) => {
        this.btndisabled=false;


        if (err.error == 'loggedin') {
         
          let showpopup = this.dialogService.addDialog(CommondialogComponent,
            {
              title: 'Please Confirm',
              message: 'Already you are logged in another location. Do you want Continue..?',
              hclass: 'modelsuccess',
              oktext: 'Yes',
              canceltext: 'No',
              okshow: true,
              cancelshow: true
            }).subscribe((isConfirmed) => {
              if (isConfirmed) {
                let encryptPassword_ = a.encryptUsingAES256(this.f.password.value.toString());
                this.loginService.login(a.encryptUsingAES256(this.f.emailid.value.toString())
                  , encryptPassword_.toString(), 1).subscribe((Login: any) => {

                this.authService.setSecureToken(Login.token);
                // Set the User data
                this.localService.setJsonValue('userid', Login.userid);
                this.localService.setJsonValue('username', Login.firstname);
                this.localService.setJsonValue('emailid', this.f.emailid.value);
                this.localService.setJsonValue('logid', Login.logid);
                this.localService.setJsonValue('apitoken', Login.apitoken);
                this.localService.setJsonValue('isautologuseronly', Login.isautologuseronly);  
                this.localService.setJsonValue('isautologteam', Login.teamid);  
                this.localService.setJsonValue('isautologadmin', Login.isautologadmin);                  
                this.isautologuseronly=+Login.isautologuseronly;
                this.isautologteam=+Login.teamid;
                this.apitoken=Login.apitoken;
                this.userrole=Login.userrole;
                //localStorage.setItem("userid", Login.userid);
                //localStorage.setItem("username", Login.firstname);
                //localStorage.setItem("logid", Login.logid);
                //localStorage.setItem("emailid", this.f.emailid.value);


                  this.signalrservice.createConnection();
                  this.signalrservice.registerOnServerEvents();
                  this.signalrservice.startConnection();

                  if((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
                    && this.userrole=='Admin') ||((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
                     && this.autologadmin==1))
                           ||(this.isautologuseronly==2))
                  {
                  this.router.navigate(['/homepage']);
                //  this.localService.setJsonValue('navmenu', false);
                  }
                  else if(this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId && this.userrole=='User'){
                    
                    let openAutologUrl='';  
                    openAutologUrl=this.autologUrl+this.apitoken+'&auth=acrn';
                    localStorage.clear();
                    // Clear the localStorage
                    this.localService.clearToken();
                   window.open(openAutologUrl,"_self");                    
                  }
                  else
                  this.router.navigate(['/home']);

                 // this.router.navigate(['/homepage']);
                 // this.router.navigate(['/home']);
                },
                  (err: HttpErrorResponse) => {
                    this.btndisabled=false;
                    this.toastr.error(err.error);
                  });
              }
              else {
              
                location.reload();
              }
            });

        }
        else {
          if(err.error.toString().includes('Password expired')){
            this.btndisabled=true;
          var str=(err.error.toString().split('*'));
          this.userid=+ str[1];
          this.changepasswordModalRef = this.modalService.show(template, this.config);
          const aa = document.getElementsByClassName('modal-content');
          aa[0].classList.remove("modal-content");
          } else {
          this.toastr.error(err.error);
          this.loading = false;
          }
        }


        //if (err.status == 400)
        //  this.toastr.error('Invalid username or password');
        //else {
        //  this.toastr.error('An Unexpected Error Occured.');
        //}


      });
  }

  doHide() {
    this.bsModalRef.hide();
  }
  ssologin() {
    this.SpinnerService.show();
    // let email = this.loginForm.value.emailid;
    // if (email == '' || email == null) {
    //   this.SpinnerService.hide();
    //   this.toastr.warning('Please Enter the Email');
    //   return;
    // }
    // localStorage.setItem('ssologinemail', email);

    this.loginService.ssoCodeGet().subscribe(res => {
      window.location.href = res.ssoLoginUrl;
    }, error => {
      this.SpinnerService.hide();
    });


    // tslint:disable-next-line: max-line-length
    // window.location.href = 'https://login.intelliconnect.inta.cch.com/as/authorization.oauth2?client_id=LB.PubCAT&response_type=code&scope=openid+profile+email&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2F%23%2F';
    // window.location.href = 'https://login.intelliconnect.inta.cch.com/as/authorization.oauth2?client_id=LB.PubCAT&response_type=code&scope=openid+profile+email&redirect_uri=http%3A%2F%2Flocalhost%3A44375%2F%23%2F';
    // window.location.href = 'https://login.intelliconnect.inta.cch.com/as/authorization.oauth2?client_id=LB.PubCAT&response_type=code&scope=openid+profile+email&redirect_uri=https%3A%2F%2Facrn-qa.wolterskluwerlr.com%2F%23%2F';
  }
  ssoPost(code) {
    this.SpinnerService.show();
    // let email = localStorage.getItem('ssologinemail');
    // localStorage.removeItem('ssologinemail');
    this.loginService.ssoPost(code).subscribe(response => {
      this.SpinnerService.hide();
      this.authService.setSecureToken(response.token);
console.log(response);
      // Set the User data
      this.localService.setJsonValue('userid', response.userid);
      this.localService.setJsonValue('username', response.firstname);
      this.localService.setJsonValue('emailid', response.emailid);
      this.localService.setJsonValue('logid', response.logid);
      this.localService.setJsonValue('apitoken', response.apitoken);
      this.localService.setJsonValue('isautologuseronly', response.isautologuseronly);  
      this.localService.setJsonValue('isautologteam', response.teamid);  
      this.localService.setJsonValue('isautologadmin', response.isautologadmin);                  
      this.isautologuseronly=+response.isautologuseronly;
      this.isautologteam=+response.teamid;
      this.apitoken=response.apitoken;
      this.userrole=response.userrole;

      //localStorage.setItem('userid', response.userid);
      //localStorage.setItem('username', response.firstname);
      //localStorage.setItem('logid', response.logid);
      //localStorage.setItem('emailid', response.emailid);
      this.signalrservice.createConnection();
      this.signalrservice.registerOnServerEvents();
      this.signalrservice.startConnection();

     // this.router.navigate(['/home']);
     if((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
      && this.userrole=='Admin') ||((this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId
       && this.autologadmin==1))
             ||(this.isautologuseronly==2)){
   this.router.navigate(['/homepage']);
  // this.localService.setJsonValue('navmenu', false);
 }
   else if(this.isautologuseronly==1 &&  this.isautologteam==this.autologUserTeamId && this.userrole=='User'){
   
     let openAutologUrl='';  
     openAutologUrl=this.autologUrl+this.apitoken+'&auth=acrn';
     localStorage.clear();
     // Clear the localStorage
     this.localService.clearToken();
    window.open(openAutologUrl,"_self");                    
   }
   else
   this.router.navigate(['/home']);


    }, error => {
      this.SpinnerService.hide();
      this.toastr.error(error.error.message);
      if (error.error.message == 'This user is not ACRN DB') {
        this.router.navigate(['/accessrequest'], {
          queryParams: {
            email: error.error.email,
            firstname: error.error.firstname,
            lastname: error.error.lastname
          }
        });

      }
    });
  }

  onSubmitpassword(http: HttpClient) {
    
    this.btndisabled=false;
    this.submittedpassword = true;
    this.loading = true;    
    var username = this.f.emailid.value.toString();
    if(+this.passwordComplexity <=69){
      this.toastr.error("Please use complex password");
      return;
    }
    if (this.p.newpassword.value != this.p.confirmpassword.value) {
      this.toastr.error("Confirm password and new password should be same");
      return;
    }
    if (this.p.oldpassword.value == this.p.newpassword.value) {
      this.toastr.error("Old password and new password should not be same");
      return;
    }
    let a= new encryptdecrypt();  
    this.encryptUsername = a.encryptUsingAES256(username.toString());
    this.encryptPassword = a.encryptUsingAES256(this.p.oldpassword.value.toString());

    console.log(this.encryptUsername );
    this.changeservice.checkoldpassword(this.encryptPassword, this.encryptUsername).subscribe(res =>
    {
      //console.log(res);
      if (res.status == 200) { this.postresult = true; this.changepassword(); };
       },
      error => {
        this.toastr.error(error.error);
        this.loading = false;
        return;
        this.postresult = false
      }) 
      
  }

  changepassword() {
    var useridnew =  this.userid;
    console.log(useridnew);
    let a= new encryptdecrypt();
    this.encryptPassword = a.encryptUsingAES256(this.p.newpassword.value.toString());
    this.encryptUserid=a.encryptUsingAES256(useridnew.toString());
    this.changeservice.changepassword(this.encryptPassword.toString(), this.encryptUserid.toString()).subscribe(res => {
     // console.log(res);
      if (res.status == 200) {
    this.postresult = true;
      this.toastr.success('Password Reset has been done successfully');
      this.changepsswordForm.controls['oldpassword'].setValue('');
      this.changepsswordForm.controls['newpassword'].setValue('');
      this.changepsswordForm.controls['confirmpassword'].setValue('');       
      this.f.emailid.setValue('');
      this.f.password.setValue('');
      this.changepasswordModalRef.hide();     
    };
      },
      error => {
        this.toastr.error(error.error);
        this.postresult = false
      })
  }
}
